import React from 'react';
import GoUpBtn from '../../common/GoUpBtn';
import { useUISettings } from '../../UISettingsProvider';
import PrematchHomeCompetition from '../prematch-home/PrematchHomeCompetition';
import PrematchHomeCompetitionMacrogruppo from '../prematch-home/PrematchHomeCompetitionMacrogruppo';

export default function Match(props) {
    const uiSettings = useUISettings();

    const match = props.match;
    const show = !uiSettings.fullScreen && match;

    if (!show) {
        return null;
    }

    return (
        <div id="secondo-blocco-sport" className={"sport-blocco secondo-blocco-sport tablesCompacted go-up-arrow-on-overflow"}>
            <GoUpBtn />
            {match.macrogruppi.length > 1 ?
                <PrematchHomeCompetitionMacrogruppo match={match} macrogruppi={match.macrogruppi} />
                :
                <PrematchHomeCompetition match={match} />
            }
        </div>
    );
}
